import { Component, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { EditLitigationDialogComponent } from '../edit-litigation-dialog/edit-litigation-dialog.component';
import { LitigationServiceEndpoints } from '@upassignations/feature';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'lib-change-entity-cell-renderer',
  imports: [],
  templateUrl: './change-entity-cell-renderer.component.html',
  styleUrl: './change-entity-cell-renderer.component.scss',
})
export class ChangeEntityCellRendererComponent
  implements ICellRendererAngularComp
{
  private dialog = inject(MatDialog);

  params: any;
  litigation: any;
  isDisabled = false;

  showListOfEntities: () => Promise<any[]>;
  modifyLitigation: (
    type: string,
    litigationUri: string,
    newValueUri: string
  ) => void;
  // eslint-disable-next-line no-unused-vars
  isServiceDeactivated: (litigation: any, serviceEndpoint: string) => boolean;

  agInit(params: any): void {
    this.params = params;
    this.litigation = params.data;

    this.showListOfEntities = params.showListOfEntities;
    this.modifyLitigation = params.modifyLitigation;
    this.isServiceDeactivated = params.isServiceDeactivated;

    this.checkIfDisabled();
  }

  refresh(params: any): boolean {
    this.params = params;
    this.litigation = params.data;
    this.checkIfDisabled();
    return true;
  }

  checkIfDisabled(): void {
    this.isDisabled =
      this.litigation?.isDeprecated ||
      this.isServiceDeactivated(
        this.litigation,
        LitigationServiceEndpoints.UPDATE_ENTITY
      );
  }

  async onChangeEntityClick(event: Event): Promise<void> {
    event.stopPropagation();
    event.preventDefault();

    if (this.isDisabled) {
      return;
    }

    try {
      await this.openChangeEntityDialog();
    } catch (error) {
      console.error("Erreur lors du changement d'entité:", error);
    }
  }

  async openChangeEntityDialog(): Promise<void> {
    try {
      const entities = await this.showListOfEntities();

      const dialogRef = this.dialog.open(EditLitigationDialogComponent, {
        width: '600px',
        data: {
          title: "Changer l'entité responsable",
          type: 'entity',
          options: entities,
          oldValue: this.litigation.responsibleEntity,
          litigationUri: this.litigation.uri,
        },
      });

      const newValueUri = await firstValueFrom(dialogRef.afterClosed());

      if (
        newValueUri &&
        newValueUri !== this.litigation.responsibleEntity?.uri
      ) {
        this.modifyLitigation('entity', this.litigation.uri, newValueUri);
      }
    } catch (error) {
      console.error("Erreur lors de l'ouverture du dialog:", error);
    }
  }
}
